import {createContext} from 'react'

export type EntryContextType = {
	channel: string
	title: string
	id: number
}

export const EntryContext = createContext<EntryContextType>(undefined)
